import { Tooltip, styled, useTheme } from "@mui/material";
import { FC } from "react";

import { ClockCounterClockwiseIcon } from "@phosphor-icons/react/dist/csr/ClockCounterClockwise";
import { FlaskIcon } from "@phosphor-icons/react/dist/csr/Flask";
import { MinusSquareIcon } from "@phosphor-icons/react/dist/csr/MinusSquare";
import { PlusSquareIcon } from "@phosphor-icons/react/dist/csr/PlusSquare";
import { StarIcon } from "@phosphor-icons/react/dist/csr/Star";

interface IconProps {
  noPadding?: boolean;
}

const IconButton = styled("a", {
  shouldForwardProp: (prop) => prop !== "noPadding",
})<IconProps>(({ theme, noPadding }) => ({
  color: `${theme.palette.surfaceLight50.main} !important`,
  textDecoration: "none",
  padding: noPadding ? "0px" : "5px",
  "&:hover": {
    color: `${theme.palette.accentInfo30.main} !important`,
    cursor: "pointer !important",
  },
}));

const IconNoHover = styled("span")(({ theme }) => ({
  color: `${theme.palette.surfaceLight50.main} !important`,
  textDecoration: "none",
  display: "inline-block",
  marginRight: "5px",
  padding: "0px",
}));

// Download Icons

const TestProofIcon = () => {
  const theme = useTheme();
  return (
    <Tooltip id="tooltip" title="Test Download: These will not show on the Imports Dashboard." arrow placement="left">
      <FlaskIcon color={theme.palette.text30.main} />
    </Tooltip>
  );
};

const BackfillIcon = () => {
  const theme = useTheme();
  return (
    <Tooltip id="tooltip" title="Backfill: Initiated manually by a user." arrow placement="left">
      <ClockCounterClockwiseIcon color={theme.palette.text30.main} />
    </Tooltip>
  );
};

const ProductionIcon = () => {
  const theme = useTheme();
  return (
    <Tooltip id="tooltip" title="Production" arrow placement="left">
      <StarIcon color={theme.palette.text30.main} />
    </Tooltip>
  );
};

const PurposeIcon = ({ purpose }: { purpose?: string | null }) => {
  if (purpose === "proof") {
    return <TestProofIcon />;
  } else if (purpose === "backfill") {
    return <BackfillIcon />;
  } else {
    return <ProductionIcon />;
  }
};

// Flow Icons
interface ToggleDetailIconProps {
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  tooltipPurpose?: string;
  className?: string;
}

const ToggleDetailIcon: FC<ToggleDetailIconProps> = ({ selected, onClick, tooltipPurpose = "", className = "" }) => {
  return (
    <Tooltip id="tooltip" title={selected ? "Hide" : "Show " + tooltipPurpose} arrow placement="left" data-cy="tooltip">
      <IconButton className={className} onClick={onClick} data-cy="tooltip-container-show-hide">
        {selected ? <MinusSquareIcon /> : <PlusSquareIcon />}
      </IconButton>
    </Tooltip>
  );
};

export { IconButton, IconNoHover, PurposeIcon, ToggleDetailIcon };
